import { useAuth } from '@/app/context';
import { UserGroup } from '@/shared/utils/get-group';
import { useEffect, useState } from 'react';

export function useIsUnderwriterUser() {
  const { checkUserGroups } = useAuth();
  const [isUnderwriterUser, setIsUnderwriterUser] = useState<boolean | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups([UserGroup.INSURER_UNDERWRITER]);
      setIsUnderwriterUser(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { isUnderwriterUser, isLoading };
}
